import { useEffect, useState } from "react";

export function useColorScheme() {
  const isDark =
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [scheme, setScheme] = useState(isDark ? "dark" : "light");

  useEffect(() => {
    const onChange = ({ matches }: MediaQueryListEvent) =>
      setScheme(matches ? "dark" : "light");

    const matchMedia = window.matchMedia("(prefers-color-scheme: dark)");
    matchMedia.addEventListener("change", onChange);

    return () => matchMedia.removeEventListener("change", onChange);
  }, []);

  return scheme;
}
